<div class="spinner" *ngIf="!dataLoaded"></div>
<ng-container *ngIf="dataLoaded">
    <ng-container *ngIf="!selectedPermit">
        <h2>Permits</h2>
        <p-table styleClass="mvd_table--notfixed" [value]="permits" [lazy]="true" (onLazyLoad)="populatePermits($event)" [paginator]="true"
                 [rows]="10" [totalRecords]="totalRecords">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th class="w--icon">Permit&nbsp;#</th>
                    <th>Permit Type</th>
                    <th>Customer Name</th>
                    <th class="w--vin">Vin</th>
                    <th class="w--icon">Select</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td>{{data.commercialVehiclePermitNumberId}}</td>
                    <td>{{data.commercialVehiclePermitTypeId | displayValue:permitTypes}}</td>
                    <td>{{data.customerName}}</td>
                    <td>{{data.vin}}</td>
                    <td class="text-center">
                        <a class="icon--select" title="Select" href="javascript:void(0);" (click)="onPermitSelected(data)"></a>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>

    <ng-container *ngIf="selectedPermit">
        <h2>Permit Details <button class="icon--remove btn--default" type="button" title="Remove" (click)="onRemovePermit()" [ngClass]="{hidden: readOnly}">Remove</button></h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-2 mvd_form-group">
                    <label>Permit Number</label>
                    <input class="mvd_form-control" disabled="" type="text" value="{{selectedPermit.commercialVehiclePermitNumberId}}">
                </div>
                <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group">
                    <label>Type</label>
                    <input class="mvd_form-control" disabled="" type="text" value="{{selectedPermit.commercialVehiclePermitTypeId | displayValue:permitTypes}}">
                </div>
                <div class="col-sm-5 col-md-4 col-lg-5 mvd_form-group">
                    <label>Customer Name</label>
                    <input class="mvd_form-control" disabled="" type="text" value="{{selectedPermit.customerName}}">
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>VIN</label>
                    <input class="mvd_form-control" disabled="" type="text" value="{{selectedPermit.vin}}">
                </div>
            </div>
        </fieldset>
    </ng-container>

    <div class="spinner" *ngIf="!resultsLoaded"></div>
    <p class="mvd_alert--label" *ngIf="resultsLoaded && (!permits || !permits.length)">No permit found. Modify your search criteria.</p>
</ng-container>